import useFetchByParams from 'shared/hooks/useFetchByParams';
import { useMemo } from 'react';
import { fetchCountryRegions, selectCountryRegions, selectCountryRegionsLoading } from 'features/regions/store/region.slice';
import { QueryParams } from 'shared/types';
import { CountryRegion } from 'shared/models';

export const useCountryRegionsQuery = (query?: QueryParams) => {
  return useMemo(() => {
    const queryParams = { ...query, limit: 'unlimited' };

    return [queryParams];
  }, []);
};

export const useCountryRegions = (query: QueryParams) => {
  return useFetchByParams<CountryRegion[]>({
    action: fetchCountryRegions,
    dataSelector: selectCountryRegions,
    loadingSelector: selectCountryRegionsLoading,
    params: query,
  });
};
